/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType } from "./http-client";
export class Marketplace {
  http;
  constructor(http) {
    this.http = http;
  }
  /**
   * @description Search public vendor profiles by query, category, commune, verification level, or location coordinates. Results are sorted by multi-factor ranking score descending.
   *
   * @tags Marketplace
   * @name SearchVendors
   * @summary Search Vendors
   * @request GET:/api/marketplace/vendors
   */
  searchVendors = (query, params = {}) =>
    this.http.request({
      path: `/api/marketplace/vendors`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Register a new vendor profile on the marketplace.
   *
   * @tags Marketplace
   * @name RegisterVendor
   * @summary Register Vendor
   * @request POST:/api/marketplace/vendors
   */
  registerVendor = (data, params = {}) =>
    this.http.request({
      path: `/api/marketplace/vendors`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Batch check: return list of all public vendor IDs saved by current organization.
   *
   * @tags Marketplace
   * @name GetSavedVendorIds
   * @summary Get Saved Vendor Ids
   * @request GET:/api/marketplace/vendors/saved-ids
   * @secure
   */
  getSavedVendorIds = (params = {}) =>
    this.http.request({
      path: `/api/marketplace/vendors/saved-ids`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve details of a single vendor profile by its ID, including its reviews.
   *
   * @tags Marketplace
   * @name GetVendorDetails
   * @summary Get Vendor Details
   * @request GET:/api/marketplace/vendors/{vendor_id}
   */
  getVendorDetails = (vendorId, params = {}) =>
    this.http.request({
      path: `/api/marketplace/vendors/${vendorId}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Update fields on a vendor profile and recalculate ranking score. Requires authentication. Only claimant or users with MANAGER or OWNER roles may update details.
   *
   * @tags Marketplace
   * @name UpdateVendor
   * @summary Update Vendor
   * @request PATCH:/api/marketplace/vendors/{vendor_id}
   * @secure
   */
  updateVendor = (vendorId, data, params = {}) =>
    this.http.request({
      path: `/api/marketplace/vendors/${vendorId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Check whether a marketplace vendor is saved by the current organization.
   *
   * @tags Marketplace
   * @name GetVendorSavedStatus
   * @summary Get Vendor Saved Status
   * @request GET:/api/marketplace/vendors/{vendor_id}/saved
   * @secure
   */
  getVendorSavedStatus = (vendorId, params = {}) =>
    this.http.request({
      path: `/api/marketplace/vendors/${vendorId}/saved`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Save/bookmark a marketplace vendor profile into organization's saved vendors.
   *
   * @tags Marketplace
   * @name SaveVendor
   * @summary Save Vendor
   * @request POST:/api/marketplace/vendors/{vendor_id}/save
   * @secure
   */
  saveVendor = (vendorId, params = {}) =>
    this.http.request({
      path: `/api/marketplace/vendors/${vendorId}/save`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Unsave/remove a marketplace vendor from organization's saved vendors.
   *
   * @tags Marketplace
   * @name UnsaveVendor
   * @summary Unsave Vendor
   * @request DELETE:/api/marketplace/vendors/{vendor_id}/save
   * @secure
   */
  unsaveVendor = (vendorId, params = {}) =>
    this.http.request({
      path: `/api/marketplace/vendors/${vendorId}/save`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Submit a review for a marketplace vendor. Auto-updates the vendor's average rating, review count, and multi-factor ranking score. If work_order_id is provided and verified, marks the review as a verified platform job.
   *
   * @tags Marketplace
   * @name AddVendorReview
   * @summary Add Vendor Review
   * @request POST:/api/marketplace/vendors/{vendor_id}/reviews
   * @secure
   */
  addVendorReview = (vendorId, data, params = {}) =>
    this.http.request({
      path: `/api/marketplace/vendors/${vendorId}/reviews`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List reviews for a vendor profile with pagination.
   *
   * @tags Marketplace
   * @name GetVendorReviews
   * @summary Get Vendor Reviews
   * @request GET:/api/marketplace/vendors/{vendor_id}/reviews
   */
  getVendorReviews = (vendorId, query, params = {}) =>
    this.http.request({
      path: `/api/marketplace/vendors/${vendorId}/reviews`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Initiate a claim on a sourced vendor profile. Generates a verification OTP.
   *
   * @tags Marketplace
   * @name InitiateClaim
   * @summary Initiate Claim
   * @request POST:/api/marketplace/vendors/{vendor_id}/claim
   * @secure
   */
  initiateClaim = (vendorId, data, params = {}) =>
    this.http.request({
      path: `/api/marketplace/vendors/${vendorId}/claim`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Submit OTP code to verify and approve the claim on a vendor profile.
   *
   * @tags Marketplace
   * @name VerifyClaim
   * @summary Verify Claim
   * @request POST:/api/marketplace/vendors/{vendor_id}/verify
   * @secure
   */
  verifyClaim = (vendorId, data, params = {}) =>
    this.http.request({
      path: `/api/marketplace/vendors/${vendorId}/verify`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Validate Chilean RUT (Modulo 11) and SEC trade license, promoting vendor to VERIFIED tier.
   *
   * @tags Marketplace
   * @name ValidateCredentials
   * @summary Validate Credentials
   * @request POST:/api/marketplace/vendors/{vendor_id}/validate-credentials
   * @secure
   */
  validateCredentials = (vendorId, data, params = {}) =>
    this.http.request({
      path: `/api/marketplace/vendors/${vendorId}/validate-credentials`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Submit a service request for a marketplace vendor.
   *
   * @tags Marketplace
   * @name SubmitVendorServiceRequest
   * @summary Submit public vendor service request
   * @request POST:/api/marketplace/vendors/{vendor_id}/service-request
   * @secure
   */
  submitVendorServiceRequest = (vendorId, data, params = {}) =>
    this.http.request({
      path: `/api/marketplace/vendors/${vendorId}/service-request`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Submit an ownership dispute against an active claim on a vendor profile.
   *
   * @tags Marketplace
   * @name DisputeVendorClaim
   * @summary Submit ownership dispute on claimed vendor profile
   * @request POST:/api/marketplace/vendors/{vendor_id}/dispute
   * @secure
   */
  disputeVendorClaim = (vendorId, data, params = {}) =>
    this.http.request({
      path: `/api/marketplace/vendors/${vendorId}/dispute`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
